import type { TPart } from "~/database/types";
import type { PartInteractionWithExtras } from "~/modules.server/part/repository";

import { PartSimilarityReview } from "./part-similarity-review";
import { SinglePartSimilarityReview } from "./single-part-similarity-review";
import type { ConfidenceLevel } from "../../parts-similarity/utils/confidence";

// AIDEV-NOTE: Dialog wrapper for part similarity suggestions - supports both session-wide and single-part modes

export interface PartSimilarityMatch {
    newPartInteraction: PartInteractionWithExtras;
    existingPart: TPart;
    confidence: ConfidenceLevel | number;
    reasoning: string;
    differences?: string;
}

interface PartSimilarityDialogProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    sessionId: string;
    partInteractionId?: string; // If provided, show single part mode
    onComplete?: (
        acceptedMatches: Array<{ interactionId: string; partId: string }>,
    ) => void;
}

export function PartSimilarityDialog({
    isOpen,
    onOpenChange,
    sessionId,
    partInteractionId,
    onComplete,
}: PartSimilarityDialogProps) {
    // Use single part mode if partInteractionId is provided
    if (partInteractionId) {
        return (
            <SinglePartSimilarityReview
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                sessionId={sessionId}
                partInteractionId={partInteractionId}
                onComplete={onComplete}
            />
        );
    }

    // Otherwise use the full session review mode
    return (
        <PartSimilarityReview
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            sessionId={sessionId}
            onComplete={onComplete}
        />
    );
}
